// import styles from "./aboutSection.css";
import aboutImage from "./../../../pages/about.jpg";
import Section from "../section";
import trips from "../../../data/trips.json";
import safaris from "../../../data/safaris.json";

function tripDetailsSection({ id, type }) {
  const tripDetails = type === 'safari' ? safaris.find((safari) => safari.id == id) : trips.find((trip) => trip.id == id);

  return (
    <Section title={tripDetails.title}>
      <div>{tripDetails.description}</div>
      <img src={aboutImage} alt="O nas" className="about-image" />
    </Section>
  );
}

export default tripDetailsSection;
